module.exports = __webpack_public_path__ + "img/7.27875476.jpg";